import ApiService from "./ApiService";

const { REACT_APP_APILOGIN } = process.env;

const GoogleAccountService =
{
    asociarGmail: function (data) {
        return ApiService.post(`${REACT_APP_APILOGIN}Usuario/AsociarGmail`, data);
    },

    desasociarGmail: function () {
        return ApiService.post(`${REACT_APP_APILOGIN}Usuario/DesasociarGmail`);
    },

    logoutGmail: function () {
        fetch('https://mail.google.com/mail/u/0/?logout&hl=en', { method: 'GET', mode: 'no-cors' }).then(response => {
            console.log(`google logout Response; ${JSON.stringify(response, null, 1)}`);
        }).catch(e => {
            console.log(e);
        });
    },

}

export default GoogleAccountService;